import { useCallback } from "react";
import { useSelector } from "react-redux";

import { dispatch } from "../../state/store";
import { setDeletedGroups, setUserGroupLoading, setUserGroupRefresh } from "../../state/ducks";

import { strCode } from "../../consts";
import { log, notificationService, t, userGroupService } from "../../services";

export const useUpdateGroups = () => {
  const groups = useSelector((store) => store.userGroups?.groups);
  const loading = useSelector((store) => store.userGroups?.loading);

  const mutationCallback = useCallback(
    async (newGroupData = []) => {
      dispatch(setUserGroupLoading(true));

      try {
        const groupsToAdd = newGroupData.filter((x) => !x.id);
        const groupsToUpdate = newGroupData.filter(
          (x) => x.id && groups.find((group) => group.id === x.id)?.name !== x.name
        );
        const groupsToDelete = groups.filter(
          (x) => !newGroupData.some((newGroup) => newGroup.id === x.id)
        );

        const promises = [];

        for (let group of groupsToAdd) {
          promises.push(userGroupService.createGroup(group.name));
        }

        for (let group of groupsToUpdate) {
          promises.push(userGroupService.updateGroup(group.id, group.name));
        }

        for (let group of groupsToDelete) {
          promises.push(userGroupService.deleteGroup(group.id));
        }

        await Promise.all(promises);
        dispatch(setDeletedGroups(groupsToDelete.map((x) => x.id)));

        dispatch(setUserGroupRefresh(true));
      } catch (err) {
        log.error("useFetchGroups: Failed to fetch groups", err);

        notificationService.showError({
          title: t(strCode.GROUP_EDIT_ERROR),
          message: err?.response?.data?.message ? err.response.data.message : err?.toString()
        });
      } finally {
        dispatch(setUserGroupLoading(false));
      }
    },
    [groups]
  );

  return { mutationCallback, data: groups, loading };
};
